import React from 'react';
import { Coffee, Utensils, GlassWater } from 'lucide-react';
export function NutritionSection() {
  return <section className="py-20 lg:py-32 px-6 bg-cream" data-id="element-140">
      <div className="max-w-6xl mx-auto" data-id="element-141">
        <div className="text-center mb-16" data-id="element-142">
          <span className="text-gold font-serif italic text-xl mb-4 block" data-id="element-143">
            Chapter 4
          </span>
          <h2 className="text-4xl lg:text-5xl font-serif text-charcoal mb-6" data-id="element-144">
            Cortisol-Conscious Nutrition
          </h2>
          <p className="text-lg text-charcoal/80 max-w-2xl mx-auto" data-id="element-145">
            We aren't counting calories; we are counting <strong data-id="element-146">Spikes</strong>
            .
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-147">
          {/* Rule 1 */}
          <div className="bg-white p-8 rounded-sm shadow-sm border-t-4 border-sage hover:shadow-md transition-shadow" data-id="element-148">
            <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center mb-6" data-id="element-149">
              <Coffee className="w-6 h-6 text-sage-dark" data-id="element-150" />
            </div>
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-151">
              The Golden Rule
            </h3>
            <p className="text-charcoal/70 text-sm leading-relaxed mb-4" data-id="element-152">
              Never drink coffee on an empty stomach. Caffeine + Fasting = A
              Cortisol explosion.
            </p>
            <div className="bg-cream p-3 rounded text-xs text-charcoal/80 font-medium" data-id="element-153">
              Action: Eat 10g protein (egg, nuts) <em data-id="element-154">before</em> your coffee.
            </div>
          </div>

          {/* Rule 2 */}
          <div className="bg-white p-8 rounded-sm shadow-sm border-t-4 border-gold hover:shadow-md transition-shadow" data-id="element-155">
            <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center mb-6" data-id="element-156">
              <Utensils className="w-6 h-6 text-gold" data-id="element-157" />
            </div>
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-158">
              The "Buffer" Plate
            </h3>
            <p className="text-charcoal/70 text-sm leading-relaxed mb-4" data-id="element-159">
              Always pair carbohydrates with a fat or fiber. This prevents the
              glucose spike that triggers a cortisol response.
            </p>
            <div className="bg-cream p-3 rounded text-xs text-charcoal/80 font-medium" data-id="element-160">
              Action: Never eat "naked" carbs. Add avocado, olive oil, or
              greens.
            </div>
          </div>

          {/* Rule 3 */}
          <div className="bg-white p-8 rounded-sm shadow-sm border-t-4 border-sage hover:shadow-md transition-shadow" data-id="element-161">
            <div className="w-12 h-12 bg-sage-light rounded-full flex items-center justify-center mb-6" data-id="element-162">
              <GlassWater className="w-6 h-6 text-sage-dark" data-id="element-163" />
            </div>
            <h3 className="text-xl font-serif text-charcoal mb-4" data-id="element-164">
              Mineral Mocktail
            </h3>
            <p className="text-charcoal/70 text-sm leading-relaxed mb-4" data-id="element-165">
              Drink at 3 PM to prevent the afternoon "crash" and salt cravings.
            </p>
            <div className="bg-cream p-3 rounded text-xs text-charcoal/80 font-medium" data-id="element-166">
              Recipe: 4oz Coconut water + pinch sea salt + squeeze of lime.
            </div>
          </div>
        </div>
      </div>
    </section>;
}